var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"erCodeWarp"},[_c('div',{staticClass:"txt"},[_vm._v("\n\t\t手机扫码访问\n\t")]),_vm._v(" "),_c('div',{staticClass:"code"},[_c('img',{attrs:{"src":_vm.images.code}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38c3686c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ercode.vue
// module id = STEW
// module chunks = 1